<div class="container-fluid py-3">
  <!-- Heading -->
  <h4 class="study-heading mb-3">Add New Location</h4>
  <form [formGroup]="locationForm" (ngSubmit)="onSubmit()">
    <div class="row g-3">
      <!-- Site Name -->
      <div class="col-12">
        <label class="form-label" for="site_name">
          Site Name <span class="required">*</span>
        </label>
        <input
          type="text"
          id="site_name"
          class="form-control"
          placeholder="Enter site name"
          formControlName="site_name"
        />
        <div
          *ngIf="
            locationForm.controls['site_name'].invalid &&
            locationForm.controls['site_name'].touched
          "
          class="text-danger small"
        >
          Site name is required
        </div>
      </div>

      <!-- Site Address -->
      <div class="col-12">
        <label class="form-label" for="site_address">
          Site Address <span class="required">*</span>
        </label>
        <input
          type="text"
          id="site_address"
          class="form-control"
          placeholder="Enter site address"
          formControlName="site_address"
        />
        <div
          *ngIf="
            locationForm.controls['site_address'].invalid &&
            locationForm.controls['site_address'].touched
          "
          class="text-danger small"
        >
          Site address is required
        </div>
      </div>

      <!-- City -->
      <div class="col-12 col-md-6">
        <label class="form-label" for="city">
          City <span class="required">*</span>
        </label>
        <select
          id="city"
          class="form-select cursor-pointer"
          formControlName="city"
          (change)="selectCity($event.target.value); onCityChange($event)"
        >
          <option value="" disabled>Select City</option>
          <option *ngFor="let city of filteredCities" [value]="city">
            {{ city }}
          </option>
        </select>
        <div
          *ngIf="
            locationForm.controls['city'].invalid &&
            locationForm.controls['city'].touched
          "
          class="text-danger small"
        >
          City is required
        </div>
      </div>

      <!-- State -->
      <div class="col-12 col-md-6">
        <label class="form-label" for="state">
          State <span class="required">*</span>
        </label>
        <select
          id="state"
          class="form-select cursor-pointer"
          formControlName="state"
          (change)="selectState($event.target.value)"
        >
          <option value="" disabled>Select State</option>
          <option *ngFor="let state of filteredStates" [value]="state">
            {{ state }}
          </option>
        </select>
        <div
          *ngIf="
            locationForm.controls['state'].invalid &&
            locationForm.controls['state'].touched
          "
          class="text-danger small"
        >
          State is required
        </div>
      </div>

      <!-- Country -->
      <div class="col-12">
        <label class="form-label" for="country">
          Country <span class="required">*</span>
        </label>
        <select
          id="country"
          class="form-select cursor-pointer"
          formControlName="country"
          (change)="selectCountry($event.target.value)"
        >
          <option value="" disabled selected>Select Country</option>
          <option *ngFor="let country of countries" [value]="country">
            {{ country }}
          </option>
        </select>
        <div
          *ngIf="
            locationForm.controls['country'].invalid &&
            locationForm.controls['country'].touched
          "
          class="text-danger small"
        >
          Country is required
        </div>
      </div>

      <!-- Buttons -->
      <div class="col-12 d-flex justify-content-end gap-2 mt-3">
        <button type="button" class="btn custom-button" data-bs-dismiss="modal">
          Cancel
        </button>
        <button
          type="submit"
          class="btn custom-button"
          [disabled]="!locationForm.valid"
        >
          Save
        </button>
      </div>
    </div>
  </form>
</div>
